import React, { useEffect, useState } from "react";
import { signup } from "../api/api"; // Import the signup function
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import "./Signup.css"; // Import the CSS file
import { Link } from "react-router-dom";

const Signup: React.FC<{ setIsAuthenticated: (isAuthenticated: boolean) => void }> = ({ setIsAuthenticated }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [retypePassword, setRetypePassword] = useState(""); // New state for retype password
    const navigate = useNavigate(); // Initialize useNavigate

    useEffect(() => {
        const session = localStorage.getItem("session");
        if (session) {
            const { expiry } = JSON.parse(session);
            if (expiry > Date.now()) {
                navigate("/dashboard"); // Redirect to chat if already logged in
            }
        }
    }, [navigate]);

    const handleSignup = async (e: React.FormEvent) => {
        e.preventDefault();
        if (password !== retypePassword) {
            console.error("Passwords do not match");
            return; // Prevent signup if passwords do not match
        }
        try {
            const response = await signup(email, password); // Use the signup function
            console.log(response);
            setIsAuthenticated(true); // Set authenticated state
            navigate("/dashboard"); // Redirect to chat page after successful signup
        } catch (error) {
            console.error("Error signing up:", error);
        }
    };

    return (
        <div className="signup-container">
            <h1>Welcome</h1>
            <form onSubmit={handleSignup} className="signup-form">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="Username or email address*" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Password" />
                <input type="password" value={retypePassword} onChange={e => setRetypePassword(e.target.value)} required placeholder="Re-type Password" />
                <button type="submit">Sign Up</button>
                <p>
                    Already have an account? <Link to="/login">Sign in here</Link>
                </p>
            </form>
        </div>
    );
};

export default Signup;
